import ArticleInterface from '@app/Interface/ArticleInterface';
import { Title } from '@patternfly/react-core';
import * as React from 'react';
import { Link } from 'react-router-dom';
import ItemLoader from '../ItemLoader';
import LatestArticleItem from './LatestArticleItem';
import PageRouteInterface from '@app/Interface/PageRouteInterface';
import ErrorResponseInterface from '@app/Interface/ErrorResponseInterface';

interface LatestArticlesProps {
    isLoading: boolean;
    articles: ArticleInterface[] | ErrorResponseInterface;
    articlePageRoute: PageRouteInterface;
}

const LatestArticles: React.FC<LatestArticlesProps> = ({ isLoading, articles, articlePageRoute }) => {

    let articlesToView: ArticleInterface[] = [];

    if (Array.isArray(articles)) {
        articlesToView = articles;
    }

    return (
        <div>
            <Title headingLevel={'h2'} className="pf-u-mb-md">Latest Articles</Title>
            {isLoading
                ? <ItemLoader />
                : articlesToView.map((article) => (
                    <LatestArticleItem key={article.id} pageId={articlePageRoute.id} path={articlePageRoute.path} article={article} />
                ))}
            <div style={{ textAlign: "right" }}>
                <Link to={articlePageRoute.path}>All articles &gt;</Link>
            </div>
        </div>
    );

}

export default LatestArticles;